import { Tags } from 'lucide-react';

import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const MenuCategoryEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={Tags}
      title="No hay categorías"
      description="Cree secciones visuales para organizar platillos, bebidas, promociones o cualquier grupo del menú."
      hint="Use Nueva categoría para crear la primera sección"
    />
  );
};

export default MenuCategoryEmpty;
